import { TextArea } from '@xemplo/text-area';

import * as S from './payrun-resubmit-amendment.styles';
import { FieldProps } from './payrun-resubmit-amendment.types';

export const ResubmitReason = (props: FieldProps) => {
  const { setPayload } = props;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setPayload(e.target.value);
  };
  return (
    <S.FormLabel>
      <div>
        Add a reason <S.OptionalLabel>(optional)</S.OptionalLabel>
      </div>
      <TextArea
        name="resubmitReason"
        placeholder="Please expand on your reason"
        aria-label="rejection reason"
        onChange={handleChange}
        rows={6}
      />
    </S.FormLabel>
  );
};
